import { NextPage } from 'next'
import { useState } from 'react'
import { FaBookmark } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { BookList } from 'web_core/assets/book/List'
import { CategorySelector } from 'web_core/assets/category'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { useAuthState, useRequireSignedIn } from 'web_core/firebase/hooks'
import { useESBooks } from 'web_core/hooks/models/useESBooks'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { ContentNavSelector } from '~/components/Utils/ContentNavSelector'
import { Heading } from '~/components/Utils/Heading'
import { useLayoutProperty } from '~/context/layout_property'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  const { user } = useAuthState()
  const [categoryId, setCategoryId] = useState<string>()
  const { books, loadMore, isReachingEnd, isLoadingMore } = useESBooks(
    user ? { type: 'bookmarks', category_id: categoryId } : null
  )
  useRequireSignedIn()

  const { headerHeight } = useLayoutProperty()

  return (
    <DefaultLayout
      head={{ title: 'ブックマークした本', index: false }}
      leftSidebar
      rightSideBar
      categoriesMenu={{ pc: true, sp: true }}
      navLinks={{ pc: true, tablet: true, sp: true }}
    >
      <Heading title="ブックマーク" icon={FaBookmark} className="mb-0" />
      <div
        className="sticky-top bg-white pt-2 pb-2 mb-2 mb-md-4"
        style={{ top: headerHeight }}
      >
        <ContentNavSelector
          active="books"
          link="/bookmarks/[contents]"
          className="mb-2 mb-md-4"
        />
        <CategorySelector
          className="fs-7"
          style={{ maxWidth: 300 }}
          value={categoryId}
          onChange={setCategoryId}
          undefinedLabel={'全てのカテゴリ'}
        />
      </div>
      <InfiniteScroll
        loadMore={async () => {
          if (isLoadingMore === false && isReachingEnd === false)
            await loadMore()
        }}
        hasMore={isReachingEnd === false}
        loader={<LoadingSpinner />}
      >
        {books && <BookList books={books} />}
      </InfiniteScroll>
    </DefaultLayout>
  )
}

export default Page
